import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { Printer } from '../model/printer';

@Injectable({
  providedIn: 'root'
})
export class PrinterService {

  constructor(private dataService: DataService) { }
    private readonly getPrintersEndPoint: string = '/printer/getPrinters/';
    private readonly getPrinterByUserIdEndPoint: string = '/printer/getPrinterByUserId/';
    private readonly printerUserUpdateEndPoint: string = '/printer/printerUserUpdate/';
    private readonly sendDirectPrintMessageEndPoint: string = '/printer/sendDirectPrintMessage/';
    private readonly printerDeleteEndPoint: string = '/printer/printerDelete/';
    private readonly getPrinterByIdEndPoint: string = '/printer/getPrinterById/';
    private readonly printerUpdateEndPoint: string = '/printer/printerUpdate/';

    async getPrinters(name?: string): Promise<Printer[]> {
        const param = { name };
        return await this.dataService.get<Printer[]>
        (this.getPrintersEndPoint, param).toPromise();
    }

    async getPrinterById(printerId: number): Promise<Printer> {
        const param = { printerId };
        return await this.dataService.get<Printer>
        (this.getPrinterByIdEndPoint, param).toPromise();
    }

    async printerUpdate(printer: Printer): Promise<boolean> {
        return await this.dataService.post<boolean>
        (this.printerUpdateEndPoint, printer).toPromise();
    }

    async printerDelete(printer: Printer): Promise<boolean> {
        return await this.dataService.post<boolean>
        (this.printerDeleteEndPoint, printer).toPromise();
    }

    async getPrinterByUserId(userId: number): Promise<Printer> {
        const param = { userId };
        return await this.dataService.get<Printer>
          (this.getPrinterByUserIdEndPoint, param).toPromise();
    }

    async printerUserUpdate(userId: number, printerId: number): Promise<boolean> {
        const param = { UserId: userId,  PrinterId: printerId};
        return await this.dataService.post<boolean>
        (this.printerUserUpdateEndPoint, param).toPromise();
    }

    async sendDirectPrintMessage(message: any): Promise<boolean> {
      return await this.dataService.post<boolean>
      (this.sendDirectPrintMessageEndPoint, message).toPromise();
  }
}
